import { render, staticRenderFns } from "./export-products.vue?vue&type=template&id=fabba9f4&"
import script from "./export-products.vue?vue&type=script&lang=js&"
export * from "./export-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports